module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/components/multiple-payment-block/multiple-payment-block.component.scss
// module id = ./src/app/modules/boxoffice-module/components/multiple-payment-block/multiple-payment-block.component.scss
// module chunks = 9